




// src/utils/apiClient.ts
import axios, { AxiosRequestConfig } from 'axios';

 const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE || 'https://services.kojabasham.ir/api';
// export const API_BASE_URL = (process.env.NEXT_PUBLIC_API_BASE || 'https://localhost:44341/api').replace(/\/+$/, '');

export function apiOrigin(): string {
  return API_BASE_URL.replace(/\/api$/i, '');
}

const BASE_URL = API_BASE_URL;

function localhostHttpsAgent(): AxiosRequestConfig['httpsAgent'] {
  if (typeof window !== 'undefined' || !BASE_URL.includes('://localhost')) return undefined;
  const nodeHttps = require('https') as typeof import('https');
  return new nodeHttps.Agent({ rejectUnauthorized: false });
}

const httpsAgent = localhostHttpsAgent();
// Common config: withCredentials=true تا کوکی‌ها ارسال/دریافت شوند.
// xsrfCookieName / xsrfHeaderName به axios می‌گوید اگر کوکی XSRF-TOKEN موجود است براساس آن هدر X-XSRF-TOKEN را قرار دهد.
const commonConfig: AxiosRequestConfig = {
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  ...(httpsAgent ? { httpsAgent } : {}),
};

// apiClient: برای درخواست‌هایی که نیاز به احراز هویت دارند (از جمله /auth/me)
export const apiClient = axios.create({ ...commonConfig });

// apiClientWithoutAuth: برای درخواست‌هایی که قبل از لاگین اجرا می‌شوند (اما باCredentials=true هم هستند)
export const apiClientWithoutAuth = axios.create({ ...commonConfig });

// optional: اگر لازم شد دستی XSRF cookie را بخوانیم (fallback) — معمولاً axios خودش انجام می‌دهد
function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return m ? decodeURIComponent(m[2]) : null;
}

const attachXsrfHeader = (cfg: AxiosRequestConfig) => {
  try {
    // اگر axios نتوانست هدر X-XSRF-TOKEN را ست کند، این fallback آن را می‌گذارد
    if (!cfg.headers) cfg.headers = {};
    const existing = (cfg.headers as any)['X-XSRF-TOKEN'] || (cfg.headers as any)['x-xsrf-token'];
    if (!existing) {
      const token = readCookie('XSRF-TOKEN');
      if (token) (cfg.headers as any)['X-XSRF-TOKEN'] = token;
    }
  } catch {}
  return cfg;
};

// interceptor برای apiClient
apiClient.interceptors.request.use((cfg) => attachXsrfHeader(cfg), (err) => Promise.reject(err));
apiClientWithoutAuth.interceptors.request.use((cfg) => attachXsrfHeader(cfg), (err) => Promise.reject(err));

// Response interceptor نمونه (اختیاری): در صورت 401 عمومی، می‌توان رفتار مرکزی انجام داد.
// apiClient.interceptors.response.use((r) => r, (err) => { /* handle global errors if you want */ return Promise.reject(err); });

export default apiClient;
